export default "__VITE_ASSET__e0e803b4__"